export const LOCIZE_PROJECT_ID = '0f0363e6-4ef6-49cf-8f1b-e0d993b4b828';
export const SELECTED_LANGUAGE_LS_KEY = '@cognite/fusion/selected-language';
